import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { ChartDeleteItem, deleteChartDetails, getDriverChartDetails } from './api'

const keys = {
  list: (
    companyId: string | number,
    driverIds: number[],
    startTime: string,
    endTime: string,
  ) =>
    [
      'driver-chart-details',
      companyId,
      [...driverIds].sort((a, b) => a - b).join(','),
      startTime,
      endTime,
    ] as const,
}

// Loads the "Dane z kart kierowców i wykresówek" grid rows for the given drivers / date range.
// Disabled until at least one driver is selected.
export function useDriverChartDetails(
  companyId: string | number,
  driverIds: number[],
  startTime: string,
  endTime: string,
) {
  return useQuery({
    queryKey: keys.list(companyId, driverIds, startTime, endTime),
    queryFn: () =>
      getDriverChartDetails(companyId, driverIds, startTime, endTime).then((r) => r.data),
    enabled: driverIds.length > 0 && !!startTime && !!endTime,
  })
}

// Deletes selected analog charts; invalidates the grid so it refetches after success.
export function useDeleteChartDetails(companyId: string | number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (items: ChartDeleteItem[]) =>
      deleteChartDetails(companyId, items).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['driver-chart-details', companyId] })
    },
  })
}
